export default {
    SET_UPDATE_USERINFO(state,userInfo){
        state.topChatUserInfo = userInfo
        localStorage.setItem('topChatUserInfo',JSON.stringify(userInfo))
    },
    SET_TOKEN(state,token){
        state.token = token;
        localStorage.setItem('topChatToken',token)
    },
    SET_CHAT_TYPE(state,type){
        state.chatType = type;
    },
    SET_APPTEMPLATE(state,obj){
        state.appTemplate = obj;
    },
    SET_APPTEMPLATE_LIST(state,obj){
        state.templateAppList = obj;
    },
    SET_CHAT_CONFIG(state,obj){
        state.chatConfig = obj;
        localStorage.setItem('chatConfig',JSON.stringify(obj))
    },
    SET_MY_TEMPLATE_LIST(state,list){
        state.myTemplateList = list;
    },
    SET_CHAT_TEMPLATE(state,obj){
        state.chatTemplate = obj;
    },
    SET_PRODUCTS_LIST(state,list){
        state.productsList = list;
    },
    SET_ISLOGIN(state,bool){
        state.isLogin = bool;
        localStorage.setItem('isLogin',bool)
    },
    SET_DEMO_QUESTIONS_LIST(state,list){
        state.demoQuestionsList = list;
    },
    SET_COIN_RECORD_DETAIL_LIST(state,list){
        state.coinRecordDetailList = list;
    },
    SET_TEMPLATE_AI_DRAW(state,obj){
        state.templateAiDraw = obj;
    },
    // 存储本地数据库中的聊天数据
    SET_SESSION_LIST(state,obj){
        state.chatList = obj;
    },
    SET_STYLE_LIST(state,list){
        state.styleList = list;
    },
    SET_COIN_PRODUCTSLIST(state,list){
        state.coinProductsList = list;
    },
    SET_TASKS_LIST(state,list){
        state.tasksList = list;
    },
    SET_INDEXEDDB(state,obj){
        state.db = obj;
    }
}